/* tslint:disable:quotemark */
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class AnalyticsGatewayHelper {
  buildGatewayUrl(path: string, apiVersion?: string): string {
    const uriParts = this.getUriParts(apiVersion);
    return uriParts.baseUri + uriParts.version + path;
  }

  buildUnversionedGatewayUrl(path: string, apiVersion?: string): string {
    const uriParts = this.getUriParts(apiVersion);
    return uriParts.baseUri + path;
  }

  private getUriParts(apiVersion: string = "V1"): { [key: string]: string } {
    const env: { [key: string]: string } =
      environment.reportsGateway[apiVersion] ??
      environment.reportsGateway["V1"];
    const baseUri: string = this.buildBaseUri(env);
    return { baseUri, version: env.version };
  }

  private buildBaseUri(env: { [key: string]: string }): string {
    const port: string = env.port;
    return `${location.protocol}//${buildGatewayHostName(env)}${
      port !== "" && port !== "80" ? ":" + port : ""
    }`;
  }
}

export function buildGatewayHostName(env: { [key: string]: string }): string {
  const pathname: string = location.pathname;
  const hostname: string = location.hostname;
  const getDomain = (hostname: string): string => {
    if (hostname.includes("staging") || hostname.includes("test")) {
      return `${env["service"]}.eu.poppulo-staging.com`;
    } else if (hostname === "admin.newsweaver.com") {
      return `${env["service"]}.eu2.poppulo-app.com`;
    } else if (hostname.includes(".eu")) {
      return `${env["service"]}.eu2.poppulo-app.com`;
    } else if (hostname.includes(".us")) {
      return `${env["service"]}.us2.poppulo-app.com`;
    }
    return hostname.replace("rep-looker-front-ui", env["service"]);
  };

  if (env["version"] === "/v1") {
    if (pathname.includes("notessa") && hostname.includes("admin")) {
      return getDomain(hostname);
    }
    return hostname.replace("rep-looker-front-ui", env["service"]);
  } else if (env["version"] === "/v2") {
    if (
      hostname.includes("reports.test") ||
      hostname.includes("reports.eu") ||
      hostname.includes("reports.us")
    ) {
      return getDomain(hostname);
    }
    return hostname.replace("rep-looker-front-ui", env["service"]);
  }
  return hostname.replace("rep-looker-front-ui", env["service"]);
}
